import { render, staticRenderFns } from "./ImageDetails.vue?vue&type=template&id=f2d23fe8"
import script from "./ImageDetails.vue?vue&type=script&lang=ts"
export * from "./ImageDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports